import chalk from 'chalk';

export default chalk;
